// extracted by mini-css-extract-plugin
export default {"root":"LoadingMessage_root__Bx0j4"};